import React from "react";
import {
  SELF_ASSESSMENT_PROCESS,
  VALIDATION_PROCESS,
} from "src/features/esg-survey/constants/survey-tracks";
import { useResizeObserver } from "src/hooks";
import styled from "styled-components";

const TRACKS = [
  { label: "Self-Assessment", points: SELF_ASSESSMENT_PROCESS },
  { label: "Verification", points: VALIDATION_PROCESS },
];

const StyledDiv = styled.div`
  li::marker {
    color: #2eb85c !important;
    font-size: 40px !important;
  }
  li {
    max-width: 400px;
  }
  position: relative;
`;

const ProcessSection = () => {
  const { width } = useResizeObserver();
  const isMobile = width < 992;

  return (
    <section className="bg-white text-black py-5">
      <div className="w-100 mx-auto  d-flex flex-column justify-content-center position-relative">
        <div className="px-5  text-center">
          <h2 style={{ fontSize: "32px" }}>The Assessment Process</h2>
          <p
            style={{ fontSize: "18px", maxWidth: "600px" }}
            className="mb-5 mx-auto"
          >
            You can choose which assessment track to take - self-assessment or
            verification track, and change from one to the other when you're
            ready.
          </p>
          <div
            className={`d-flex  ${
              isMobile ? "flex-column" : "flex-row"
            } mb-3 justify-content-center `}
            style={{
              gap: "6rem",
            }}
          >
            {TRACKS.map((track, index) => (
              <StyledDiv key={index}>
                <h3>{track.label}</h3>
                <ul
                  style={{
                    fontSize: "16px",
                  }}
                  className="d-flex flex-column justify-content-between text-left h-100"
                >
                  {track.points.map((step, i) => (
                    <li key={i}>{step}</li>
                  ))}
                </ul>
                <div
                  style={{
                    backgroundColor: "#2eb85c",
                    position: "absolute",
                    top: 64,
                    left: 14,
                    height: "92%",
                    width: "2px",
                  }}
                />
              </StyledDiv>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
